<template>
  <div class="loading" v-show="visible">
    <!-- <div class="mask"></div> -->
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: false
    }
  }
}
</script>
<style lang="less" scoped>
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
}

.mask {
  background-color: #999;
  width: 100%;
  height: 100%;
  opacity: 0.3;
}

.spinner {
  margin: 100px auto;
  width: 150px;
  // height: 60px;
  text-align: center;
  // font-size: 10px;

  position: absolute;
  top: 0;
  left: 50%;
  top: 20%;
}

.spinner > div {
  background-color: #438DF7;
  height: 30px;
  width: 30px;
  display: inline-block;
  border-radius: 100%;

  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0.0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes bouncedelay {
  0%, 80%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 40% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/indicator/indicator.vue